import {Component, Input} from "@angular/core";
import {DesktopDropMenuInterface} from "./desktop-drop-menu-interface";

@Component({
  selector: 'yo-desktop-drop-menu',
  templateUrl: './desktop-drop-menu.component.html',
  styleUrls: ['./desktop-drop-menu.component.scss'],
  standalone: false
})
export class DesktopDropMenuComponent {

  @Input() items : DesktopDropMenuInterface[] = [];

  labelToId(label: string): string {
    return label.toLowerCase().replace(/\s+/g, '-');
  }

  hasChildren(item: DesktopDropMenuInterface): boolean {
    return item.items && item.items.length > 0;
  }

  toggleDropDown(event: Event, item: DesktopDropMenuInterface): void {
    if (!this.hasChildren(item)) {
      return;
    }

    const formattedLabel = this.labelToId(item.label);
    const targetElement = event.target as HTMLElement;
    const menuContainer: HTMLElement | null = targetElement.closest(`#${formattedLabel}-menu`);
    const liste: HTMLElement = this.getListToToggle(menuContainer, formattedLabel);
    const arrow: HTMLElement = this.getArrowToRotate(menuContainer, formattedLabel);
    if (liste && arrow) {
      this.toggleDisplay(liste, arrow);
    }
  }

  getListToToggle(parentElement: HTMLElement, label: string): HTMLElement {
    return parentElement.querySelector(`#${label}-children`);
  }

  toggleDisplay(list: HTMLElement, arrow: HTMLElement): void {
    if (list.style.display === "none" || list.style.display === "") {
      this.toggleArrowOrientation(arrow, "down");
      this.toggleListDisplay(list, true);
    } else {
      this.toggleArrowOrientation(arrow, "right");
      this.toggleListDisplay(list, false);
    }
  }

  toggleListDisplay(list: HTMLElement, toDisplay: boolean): void {
    if (toDisplay) {
      list.style.display = "block";
      setTimeout(() => {
        list.classList.add('fade-in');
      }, 10);
    } else {
      list.classList.remove("fade-in");
      setTimeout(() => {
        list.style.display = "none";
      }, 10);
    }
  }

  getArrowToRotate(parentElement: HTMLElement, label: string): HTMLElement {
    return parentElement.querySelector(`#${label}-icon`);
  }

  toggleArrowOrientation(arrow: HTMLElement, direction: string): void {
    if (direction === "down") {
      arrow.classList.add("rotate-bottom");
      arrow.classList.remove("rotate-right");
    } else {
      arrow.classList.add("rotate-right");
      arrow.classList.remove("rotate-bottom");
    }
  }
}
